  <div class="reset-card">

    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
      <div class="grid">
        <div class="field col-12">
 <label for="password" class="required-label">New Password</label>
      <input type="password"
             placeholder="New Password"
             formControlName="password"
             class="input-box"
             (input)="checkPasswordStrength();checkconfirmPassword()" />
        </div>
      </div>
   

      <div class="grid">
        <div class="field col-12">
 <label for="confirmPassword"  class="required-label">Confirm New Password</label>

      <input type="confirmPassword"
             placeholder="Confirm New Password"
             formControlName="confirmPassword"
             class="input-box" (input)="checkconfirmPassword()"/>
        </div>
      </div>

   
             <!-- <span class="colorred" *ngIf="invalidconfrimpswd"> Confrim Password not matched</span> -->

      <div class="button-group">
        <button type="submit"
                class="continue-btn"
                [disabled]="!resetForm.valid || !allRulesPassed()">
          Continue
        </button>
        <button class="cancel-btn" type="button"(click)="cancel()">Cancel</button>
      </div>

    </form>

    <div class="rules-box">
      <p class="boldbalctext">Password must contain the following:</p>
      <ul>
        <li *ngFor="let rule of ruleList">
          <i class="pi"
             [ngClass]="rule.check ? 'pi-check-circle valid-icon' : 'pi-times-circle invalid-icon'">
          </i>
          <span [ngClass]="rule.check ? 'valid-text' : 'invalid-text'">
            {{ rule.label }}
          </span>
        </li>
      </ul>
    </div>

  </div>